<script>
import { getDb } from '../data/db';
import { user } from '../data/user';
import { tooltipTop } from '../tooltip';
import Hero from './Hero.svelte';
import SprintCreator from './SprintCreator.svelte';

const sprintTip = `A Word Sprint is a timed challenge where you write as much as you can.`;

</script>

<Hero/>
<section>
	<div class="creation">
		<div class="box">
			<h1>Create your own <span class="sprint" use:tooltipTop={sprintTip}>word sprint</span></h1>
			<SprintCreator/>
		</div>
	</div>
</section>
<section>
	<div class="sprints-btn">
		<a class="btn primary large" href="/sprints">Join a Sprint</a>
	</div>
</section>

<section>
	<div class="directions">
		<p>This is a free service provided <strong>as-is</strong> by <strong><a href="https://www.dabblewriter.com/">Dabble</a></strong>.
			We create software for novelists.
		</p>
		<p>
			Your words are <strong><em>stored on this device only</em></strong> to increase privacy and reduce server costs.
			They will be <strong>deleted 24 hours</strong> after completion.
			Be sure to <strong>copy-paste your content</strong> if you want to keep it.
		</p>
		<p>
			Group Sprint data is stored on our servers until <strong>24 hours</strong> after completion. Only your word count
			is sent to our servers.
		</p>
	</div>
</section>

<section class="footer">
	<div class="footer-content">
		© Dabble Writer, Inc.
	</div>
</section>

<style>
.creation {
	margin-top: -100px;
	max-width: 660px;
}
.box {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: var(--white);
	box-shadow: 0 1px 3px 0 rgba(0,0,0,0.20), 0 2px 4px 0 rgba(0,0,0,0.20);
	border-radius: 5px;
	padding: 48px;
}
.directions {
	max-width: 660px;
	margin: 32px auto 0;
	line-height: 1.5;
  font-size: var(--font-size-100);
	color: var(--warm-grey-400);
	text-align: center;
}
.sprint {
	font-weight: 200;
	font-style: italic;
	cursor: help;
	border-bottom: 1px dotted var(--warm-grey-200);
	white-space: nowrap;
}
.box h1 {
  margin: 0 0 32px;
  text-align: center;
}
.sprints-btn {
	padding-top: 8px;
	text-align: center;
}
.sprints-btn .btn {
	width: 272px;
}
.footer-content {
	margin: 32px auto;
	text-align: center;
	color: var(--warm-grey-400);
	font-size: var(--font-size-100);
	max-width: 660px;
}
@media (max-width: 660px) {
	.box {
		padding: 12px;
	}
	.box h1 {
		font-size: var(--font-size-600);
	}
	.directions {
		margin: 32px 8px 0;
	}
}
</style>